<template>
  <v-dialog v-model="dialog" width="550">
    <template v-slot:activator="dialogProps">
      <Tooltip v-slot:default="tooltipProps" :text="$t('button_descriptions.form.display_settings')">
        <v-btn v-on="{...tooltipProps.on, ...dialogProps.on}">
          <v-icon>manage_accounts</v-icon>
        </v-btn>
      </Tooltip>
    </template>
    <v-sheet>
      <v-card>
        <v-card-title>
          <h3>Ustawienia wyświetlania</h3>
          <v-btn icon style="position: absolute;right: 0;" @click="dialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <v-flex xs12>
            <v-slider v-model="columnWidth" label="Szerokość kolumny" max="250"
                      min="50" step="10" @change="updateState()"></v-slider>
          </v-flex>
          <v-flex xs12>
            <v-select
                v-model="hiddenFields"
                :items="fields"
                chips
                hint="Pola, które nie są wyświetlane"
                item-text="name"
                item-value="order"
                label="Ukryte pola"
                multiple
                persistent-hint
                @change="updateState"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <div>
              <v-btn v-if="advancedSort && sortFieldCount < 3"
                     icon small
                     style="float:right" @click="sortFieldCount=sortFieldCount<3 ? sortFieldCount + 1 : sortFieldCount">
                <v-icon>
                  add
                </v-icon>
              </v-btn>
              <v-checkbox v-model="advancedSort" label="Zaawansowane sortowanie"
                          @click="advancedSortChanged"></v-checkbox>
            </div>
          </v-flex>

          <div v-if="advancedSort">
            <v-flex v-for="i of sortFieldCount" :key="i" xs12>
              <v-select
                  v-model="sortField[i]"
                  :items="fields"
                  :label="`Stortowanie ${i}`"
                  item-text="name"
                  item-value="order"
                  persistent-hint
                  @change="updateSort()"
              ></v-select>
              <v-select
                  v-model="sortType[i]"
                  :items="sortTypes"
                  :label="`Stortuj ${i}`"
                  item-text="name"
                  item-value="value"
                  persistent-hint
                  style="margin-bottom: 1rem"
                  @change="updateSort()"
              ></v-select>
            </v-flex>
          </div>
          <v-flex xs12>

          </v-flex>
          <v-flex style="margin-top: 1rem" xs12>
            <p>
              Ustawienia zapisywane są automatycznie po zmianie dla aktualnego schematu.<br>
              Szerokość kolumn oraz ukrywanie kolumn podstawowych (autor, data utworzenia) można zapisać jako
              domyślne ustawienia poprzez kliknięcie niebieskiego przycisku.
            </p>
          </v-flex>
          <v-flex xs12>

            <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.form.save_local')">
              <v-btn color="green lighten-2" @click="updateState" v-on="on">
                <v-icon>save</v-icon>
              </v-btn>
            </Tooltip>

            <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.form.save_global')">
                <v-btn color="blue lighten-2" @click="saveGlobal" v-on="on">
                  <v-icon>public</v-icon>
                </v-btn>
            </Tooltip>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-sheet>
  </v-dialog>
</template>

<script>

import Tooltip from "../common/Tooltip.vue"

const BASE_FIELDS = [
  {name: "Autor", order: "created_by"},
  {name: "Data utworzenia", order: "created_at"}
]

const GLOBAL_FIELDS_ORDER = ["created_by", "created_at"]

export default {
  components: {Tooltip},
  data() {
    return {
      dialog: false,
      columnWidth: 200,
      hiddenFields: [],
      advancedSort: false,
      sort: [],
      sortField: {},
      sortType: {},
      sortTypes: [{name: "Malejąco", value: "desc"}, {name: "Rosnąco", value: "asc"}],
      sortFieldCount: 1
    }
  },
  computed: {
    fields() {
      if (this.$store.state.forms.schema == null) {
        return []
      }

      let fields = this.$store.state.forms.schema.fields.map(field => ({...field}))
      fields.forEach(el => el.order = String(el.order))

      return BASE_FIELDS.concat(fields)
    }
  },
  watch: {
    columnWidth: function () {
      if (this.columnWidth == this.$store.state.formViewOptions.columnWidth) {
        return
      }

      this.$store.commit('setFormViewOptions', {
        columnWidth: this.columnWidth,
        ...this.$store.state.formViewOptions
      })
    }
  },
  mounted() {
    this.columnWidth = this.$store.state.formViewOptions.columnWidth
    this.hiddenFields = this.$store.state.formViewOptions.hiddenFields
    this.initSort()
  },
  methods: {
    advancedSortChanged() {
      if (!this.advancedSort) {
        this.sortType = {}
        this.sortField = {}
      }
    },
    initSort() {
      this.sort = this.$store.state.formViewOptions.sort

      if (!this.sort || this.sort.length == 0) {
        return
      }

      this.advancedSort = true
      this.sortFieldCount = this.sort.length

      for (let key in this.sort) {
        this.sortField[Number(key) + 1] = this.sort[key].sortField
        this.sortType[Number(key) + 1] = this.sort[key].sortType
      }
    },
    updateSort() {
      let sort = []
      for (let key in this.sortField) {
        sort.push({
          sortField: this.sortField[key],
          sortType: this.sortType[key]
        })
      }
      this.sort = sort
      this.updateState()
    },
    saveGlobal() {
      let payload = this.getPayload('global')
      payload.data.hiddenFields = payload.data.hiddenFields
          .filter(v => GLOBAL_FIELDS_ORDER.includes(v))

      this.$store.dispatch('updateFormViewOptions', payload)
      this.dialog = false
    },
    updateState() {
      this.$store.dispatch('updateFormViewOptions', this.getPayload(this.$route.params.schemaId))
    },
    getPayload(id) {
      return {
        id: id,
        data: {
          columnWidth: this.columnWidth,
          hiddenFields: this.hiddenFields,
          sort: id == 'global' ? [] : this.sort
        }
      }
    }
  }
}
</script>

<style scoped>

</style>